<template>
  <div class="table-responsive">
    <table :id="table_id" class="display table table-striped table-bordered" style="width:100%; text-align: center;">
      <thead>
        <tr>
          <th style="width: 30% !important">Name</th>
          <th style="width: 15% !important">IC Number</th>
          <th style="width: 15% !important">Mobile Number</th>
          <th style="width: 15% !important">SMS</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, index) in arrayData" :key="index">
          <td>{{ data.name }}</td>
          <td>{{ data.ic_number }}</td>
          <td>{{ data.mobile_number }}</td>
          <td>
            {{ formatSmsChecking(data.sms_sent) }} <button class="btn btn-primary ml-2" @click="() => resendSms(data.id, data.sms_sent)">Send SMS </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { sendSms } from '../../../../services/MassNotificationService';

export default {
  components: { },
  props: {
    table_id: {
      type: String,
      default: "table-id"
    },

    arrayData: {
      type: Array,
      default: []
    }


  },

  data() {
    return {

    }
  },

  methods: {
    async resendSms(id, sms_sent) {
      try {
        const response = await sendSms(id, {});

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });

        if(response.data.success) {
          const updatedSmsSent = 3;
          this.$emit('update:arrayData', this.arrayData.map(user =>
            user.id === id ? { ...user, sms_sent: updatedSmsSent } : user
          ));
        }
      } catch (e) {
        console.error(e);
      }
    },


    formatSmsChecking(smsStatus) {
      switch (smsStatus) {
        case null:
          return 'Not Yet Sent';
        case 1:
          return 'Sent';
        case 2:
          return 'Invalid';
        case 3:
          return 'Resent';
      }
    }
  },
}

</script>
